const getUserName = (user: any) => {
	const name = `${user?.first_name} ${user?.last_name}`
	return name
}
export default getUserName
